var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.267 2.167a1.1 1.1 0 0 0-1.1 1.1V9.4a1.1 1.1 0 0 0 1.1 1.1H5.5v2.234a1.1 1.1 0 0 0 1.1 1.1h6.133a1.1 1.1 0 0 0 1.1-1.1V6.6a1.1 1.1 0 0 0-1.1-1.1H10.5V3.267a1.1 1.1 0 0 0-1.1-1.1H3.267ZM9.99 6.5a.464.464 0 0 0 .018 0h2.724a.1.1 0 0 1 .1.1v6.134a.1.1 0 0 1-.1.1H6.6a.1.1 0 0 1-.1-.1V6.6a.1.1 0 0 1 .1-.1h3.39Zm-.491-1V3.267a.1.1 0 0 0-.1-.1H3.267a.1.1 0 0 0-.1.1V9.4a.1.1 0 0 0 .1.1H5.5V6.6a1.1 1.1 0 0 1 1.1-1.1h2.9Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export default ForwardRef;